var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rect',{staticClass:"bar",style:({fill: _vm.color}),attrs:{"x":_vm.data.x,"y":_vm.data.y,"width":_vm.scaleX.bandwidth(),"height":_vm.height - _vm.data.y}})}
var staticRenderFns = []

export { render, staticRenderFns }